import { DialogProps } from '@mui/material';
import { type TFunction } from 'i18next';
import { IComponentWithCustomScrollbarProps } from '../../services';
import Dialog from '../Dialog';
import DialogActions from '../Dialog/components/DialogActions';
import DialogContent from '../Dialog/components/DialogContent';
import DialogTitle from '../Dialog/components/DialogTitle';
import Button, { ButtonProps } from '../Button';
import Grid from '../Grid';

export { default as PromptList, type IPromptListProps } from './components/PromptList';

export interface IPromptDialogProps extends DialogProps, IComponentWithCustomScrollbarProps {
  t?: TFunction<'translation', undefined>;
  approvalButtonText?: string;
  rejectionButtonText?: string;
  onSubmit: () => void;
  onClose?: () => void;
  isLoading?: boolean;
  approvalButtonColor?: ButtonProps['color'];
}

const PromptDialog = (props: IPromptDialogProps) => {
  const {
    t,
    open,
    onSubmit,
    onClose,
    title,
    children,
    approvalButtonText = t ? t('common.apply') : undefined,
    rejectionButtonText = t ? t('common.cancel') : undefined,
    isLoading = false,
    approvalButtonColor = 'error',
    disableCustomScrollbar = false,
    ...restProps
  } = props;

  return (
    <Dialog
      {...restProps}
      open={open}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      clickOutsideToClose={!isLoading}
    >
      <DialogTitle isLoading={isLoading} onClose={onClose}>{title}</DialogTitle>
      {children && (
        <DialogContent disableCustomScrollbar={disableCustomScrollbar}>
          {children}
        </DialogContent>
      )}
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button color={approvalButtonColor} onClick={onSubmit} isLoading={isLoading} fullWidth>
              {approvalButtonText}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button onClick={onClose} disabled={isLoading} variant="outlined" fullWidth>
              {rejectionButtonText}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default PromptDialog;
